export default __webpack_public_path__ + "static/media/zeus_1.b618dd6a.jpg";